export default "__VITE_ASSET__hfVz2mpi__"